import {SelfInterview} from './SelfInterview';
export default SelfInterview;
